import environment from '@config/environment';
import { CALLER_HEADER, CALLER_VALUE } from '@/api/callerHeader';

const getTrustpilotApiBaseUrl = (): string => {
  const env = (environment.ENVIRONMENT || '').toLowerCase();
  if (env === 'staging' || env === 'development' || env === 'dev') {
    return 'https://vnext-be.stage.azure.viome.com';
  }
  return 'https://vnext-be.viome.com';
};

export type TrustpilotInvitationLinkRequest = {
  order_id: string;
  name: string;
  email: string;
  locale?: string;
  redirect_uri?: string;
};

export type TrustpilotInvitationLinkResponse = {
  id: string;
  url: string;
  order_id: string;
};

export const fetchTrustpilotInvitationLink = async (
  payload: TrustpilotInvitationLinkRequest,
): Promise<string> => {
  const response = await fetch(
    `${getTrustpilotApiBaseUrl()}/api/v1/trustpilot/invitation-link`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        [CALLER_HEADER]: CALLER_VALUE,
      },
      body: JSON.stringify({
        order_id: payload.order_id,
        name: payload.name,
        email: payload.email,
        locale: payload.locale ?? 'en-US',
        ...(payload.redirect_uri ? { redirect_uri: payload.redirect_uri } : {}),
      }),
    },
  );

  if (!response.ok) {
    throw new Error(`Trustpilot invitation link failed: ${response.status}`);
  }

  const data = (await response.json()) as TrustpilotInvitationLinkResponse;
  if (!data?.url) {
    throw new Error('Trustpilot invitation link response missing url');
  }

  return data.url;
};
